import request from '../../../../shared/request'
import moment from 'moment'
import queryString from 'qs'

export function getJobList(filters) {
  const qs = queryString.stringify(filters)
  return request(`/reports/general/open-items-report/job-list?${qs}`)
}

export function getOrganizationList(filters) {
  return request(`/reports/general/open-items-report/organization-list/`)
}

export function getFullReport(filters) {
  // mount query string
  let qs = ''

  // add date range
  qs += `?startDate=${moment(filters.date_range[0]).format('YYYY-MM-DD')}&endDate=${moment(
    filters.date_range[1]
  ).format('YYYY-MM-DD')}`

  // add job
  if (filters.job_id) qs += `&job_id=${filters.job_id}`

  // add organization id
  if (filters.organization_id) qs += `&organization_id=${filters.organization_id}`

  // add entities
  if (filters.entities && filters.entities.length > 0) {
    for (const entity of filters.entities) {
      qs += `&entities[]=${entity}`
    }
  }

  return request(`/reports/general/open-items-report/full-report/${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/general/openItems.js